import { ErrorIcon } from '@axa-japan/design-system-react/Icons';
import React from 'react';

type ErrorMessageProps = {
  message: string;
};

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  return (
    <div className="flex align-text-bottom gap-1 text-statusDanger">
      <div>
        <ErrorIcon size="small" />
      </div>
      <div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default ErrorMessage;
